import React from 'react';


const UserContext = React.createContext({ user: {} }); // Create a context object

export const UserProvider = UserContext.Provider
export const UserConsumer = UserContext.Consumer

export default UserContext